export type TServerTimezone = {
    shortName: string;
    name: string;
    offset: string;
};

export const getTimezoneInUse = (
    chosen: string | null,
    serverTimezones: TServerTimezone[],
    serverDefault?: string
): TServerTimezone | undefined =>
    serverTimezones.find((tz) => tz.shortName === chosen) ??
    serverTimezones.find((tz) => tz.shortName === serverDefault) ??
    serverTimezones[0];
